import { Expose } from "class-transformer";

export class HeaderNavigationModel {
  @Expose({ name: 'admin_id' })
  adminId!: number;
  @Expose({ name: 'id' })
  id!: number;
  @Expose({ name: 'position' })
  position!: number;
  @Expose({ name: 'project_id' })
  projectId!: number;
  @Expose({ name: 'tab' })
  tab!: string;
  @Expose({ name: 'visible' })
  visible!: boolean;
}